import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PriceFormatPipe } from '@/common/pipes/price-format.pipe';
import { DriversSalaryV2StateService } from '../_services/drivers-salary-v2.state.service';

@Component({
	selector: 'app-salary-ledger-pending',
	standalone: true,
	imports: [
		CommonModule,
		MatCardModule,
		MatFormFieldModule,
		MatInputModule,
		MatProgressSpinnerModule,
		PriceFormatPipe,
	],
	templateUrl: './salary-ledger-pending.component.html',
	styleUrl: './salary-shared.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SalaryLedgerPendingComponent {
	readonly state = inject(DriversSalaryV2StateService);
}
